export default {
    toggleLanguageText: "English",
    changePasswordTitle: 'Cambio de contraseña',
    changePasswordHelpText: 'Ingresa la nueva contraseña que vas a utilizar',
    changePasswordSuccessful: 'Registro actualizado con éxito',
    changePasswordFail: 'Error al actualizar registro',
    newUploadTitle: 'Nueva Carga',
    newUploadHelperText1: 'Usted puede seleccionar los archivos en la opción Ruta',
    newUploadHelperText2: 'o simplemente los puede arrastrar y soltar en esta tabla.',
    newUploadAddButtonText: 'Añadir',
    newUploadUploadButtonText: 'Subir',
    newUploadHeaderFile: 'Archivo',
    newUploadHeaderSize: 'Tamaño',
    newUploadConfirmationTitle: 'Confirmación',
    newUploadConfirmationText: '¿Está seguro de querer eliminar este archivo de la lista?',
    newUploadFileRestrictionsText: 'Sólo se aceptan archivos con extensión de imagen, PDF, Excel o XML.',
    newUploadInternationalRestrictionsText: 'Sólo se aceptan archivos con extensión de imagen, Excel o PDF.',
    newUploadNationalRestrictionsText: 'Sólo se aceptan archivos con extensión XML.',
    newUploadHelperText3: 'El archivo ',
    newUploadAlreadySelected: ' ya ha sido seleccionado.',
    newUploadAlreadyAdded: ' ya ha sido agregado a la lista.',
    newUploadNeedsFileToAdd: 'Favor de seleccionar al menos un archivo.',
    newUploadNeedsFileToUpload: 'Para subir archivos, se debe tener al menos un archivo en la lista.',
    newUploadSuccess: 'La lista de archivos se ha guardado exitosamente.',
    newUploadSizeOverflow: 'Tamaño total de archivos excede el permitido por el servidor.',
    newUploadError: 'Ocurrió un error durante el guardado de los archivos. Favor de intentar más tarde.',
    newUploadRemoveFile: 'El archivo ha sido eliminado de la lista con éxito.',
    newUploadNationalSupplierFilesError: 'Proveedores Nacionales deben subir por lo menos un archivo XML y PDF',
    newUploadFileNameError: 'El nombre del archivo PDF debe coincidir con el de un archivo XML.',
    menuTracking: 'Seguimiento',
    menuNewUpload: 'Nueva Carga',
    menuPaymentStatus: 'Estatus Pagos',
    menuChangePassword: 'Cambio de Contraseña',
    menuSignOut: 'Cerrar Sesión',
    paymentStatusTitle: 'Estatus de Pagos',
    paymentStatusHelpText: 'Whirlpool comprometido con la calidad de sus procesos y con el cumplimiento de cada uno de los objetivos de su estrategia les proporciona el Portal E-Pagos, con el fin de brindar siempre la mejor información a nuestros aliados estratégicos.',
    paymentStatusButtonText: 'Ir al sitio',
    trackingTitle: 'Seguimiento',
    trackingExportButtonText: 'Exportar CSV',
    trackingToggleFiltersButtonText: 'Filtros',
    trackingNewButtonText: 'Nuevo',
    trackingHeaderInvoiceNo: 'No. de Factura',
    trackingHeaderRelatedDoc: 'Docto. Relacionado',
    trackingHeaderRemission: 'Remisión',
    trackingHeaderUploadDate: 'Fecha de Carga',
    trackingHeaderInvoiceDate: 'Fecha de la Factura',
    trackingHeaderStatus: 'Estatus',
    trackingHeaderDetails: 'Detalles',
    trackingHeaderPhase: 'Fase',
    trackingHeaderAutomaticNotes: 'Comentarios Automáticos',
    trackingHeaderManualNotes: 'Comentarios Manuales',
    loginWelcomeText: "Bienvenido",
    loginSupplierText: "Proveedor",
    loginTitle: "Acceso de Usuario",
    loginSignup: 'Registrarse',
    loginButtonText: 'Iniciar Sesión',
    loginRecoverText: 'Si no tiene sus credenciales de acceso, por favor, enviar un correo a ',
    loginRecoverStrongText: 'MEX_AP_SUPPORT@WHIRLPOOL.COM o llamar al tel. 01 8183 29 00 00.',
    loginHelpText: "En caso de no visualizar los avisos, favor de activar los pop-ups de tu navegador.",
    loginWrongCredentials: "Usuario o contraseña incorrectos.",
    loginEmptyFields: "Favor de llenar todos los campos.",
    loginRecoveryLink: "¿Olvidaste tu contraseña?",

    passwordRecoveryFormTitle: "Cambio de contraseña",
    passwordRecoveryFormSubtitle: "Ingresa tu correo electrónico para recibir tu enlace",
    passwordRecoveryFormEmailLabel: "Correo Electrónico",
    passwordRecoveryFormInvalidEmail: "El email no es valido",
    passwordRecoveryFormReturnLink: "Regresar a login",
    passwordRecoveryFormSuccess: "Se ha enviado el correo exitosamente",
    passwordRecoveryFormFail: "No se ha podido enviar el correo de recuperación",
    
    passwordRecoveryTitle: "Recuperación de contraseña",
    passwordRecoverySubtitle: "Ingresa tu nueva contraseña",
    passwordRecoveryNewPasswordLabel: "Nueva Contraseña",
    passwordRecoveryConfirmPasswordLabel: "Confirmar Contraseña",
    passwordRecoveryPasswordsDoNotMatch: "Contraseña no coincide",
    passwordRecoveryInvalidToken: "El link de recuperación es invalido",
    passwordRecoveryInvalidPassword: "La contraseña no es valida",
    passwordRecoverySuccess: "Su contraseña ha sido cambiada.",
    passwordRecoveryFail: "No se pudo actualizar la contraseña",
    PasswordRecoveryFailCode4: "La contraseña debe ser de al menos 8 caracteres",

    signupHelpText: '*La contraseña será la misma que el RFC, al ingresar la podrás cambiar',
    signupSuccessful: 'Registro creado con éxito',
    signupFail: 'Error al crear registro',
    signupFailCodeNotFound: 'No se encontró el Vendor Number',
    signupFailCodeTaken: 'El código ya  está vinculado a un proveedor',
    signupFailRfcNoMatch: 'El RFC no coincide con el registro',
    signupFailEmailTaken: 'El Correo electrónico ya está vinculado a un proveedor',
    versionRetrievalFail: 'No se pudo obtener la version',
    formBusinessName: 'Razón Social',
    formContactEmail: 'Correo electrónico del contacto',
    formTaxID: 'RFC',
    formSupplierCode: 'Vendor Number',
    formContactName: 'Nombre del contacto',
    formContactPhone: 'Teléfono del contacto',
    formPassword: 'Contraseña',
    formNewPassword: 'Contraseña nueva',
    formConfirmNewPassword: 'Confirmar contraseña nueva',
    formRequiredField: 'Campo requerido',
    formInvalidInput: 'Campo no válido',
    formRequiredPhoneFormat: 'Se espera el código internacional (1-3 dígitos) seguido de 10 dígitos (e.g. +52 81 1234 5678)',
    formDifferentPasswords: 'Contraseña no coincide',
    formPath: 'Ruta',
    formInvoiceNo: 'No. de Factura',
    formInvoiceDate: 'Fecha de la Factura',
    formStatus: 'Estatus',
    backButtonText: 'Regresar',
    saveButtonText: 'Guardar',
    dataTableNoFiles: 'No hay archivos seleccionados para cargar.',
    dataTableNoData: 'No hay registros para sus parámetros de búsqueda. Favor de intentar otra búsqueda o crear uno nuevo.',
    datetimePickerAccept: "Aceptar",
    datetimePickerCancel: "Cancelar",
    datetimePickerClean: "Limpiar",
    statusKey: "spanishText",
    noComments: 'Sin comentarios',
    noRelatedDoc: 'Ninguno',
    noRemissionAssinged: 'Ninguno',

    dialogBtnClose: 'Cerrar',
    dialogBtnSave: 'Guardar',
    dialogRequiredFields: 'Campos requeridos',
    dialogTitle: 'Docto. Relacionado',
    dialogValidationSelect: 'Selecciona una opción',
    dialogValidationText: 'No debe ir vacío',
    relatedDocConsignment: 'Consignación',
    relatedDocPO: 'Órden de compra',
    relatedDocShipmentNum: 'Fletes',
    relatedDocTypeTitle: 'Tipo *',
    relatedDocTypeValue: 'No. Docto. Relacionado *',
    relatedDocAssignedMessage: 'Se asignó el documento correctamente',
    relatedDocErrorMessage: 'Ocurrió un error al asignar documento',
    getSupplierTypeErrorMessage: 'Ocurrió un error al obtener tipo de proveedor',
    remissionTitle: 'Remisión',
    remissionText: 'Escriba el número de remisión *',

    noTemplate: "No puedes subir archivos por el momento. Tu template no ha sido dado de alta por nuestro equipo. Favor de contactarnos para cualquier duda.",
    
    trackingInvalidPageNumber: 'No existe el número de página ingresado',
    trackingErrorGetList: 'Hubo un problema al obtener la lista',
    trackingErrorGetStatuses: 'Hubo un problema al obtener la lista de estatus',
    trackingErrorProcessCSV: 'Hubo un problema al procesar el CSV'
}